// Graph and workspace filters are stored as free-form json. Besides a flat list of filters the
// field can hold a single filter or an expression tree: {condition, expressions: [...]} whose
// items are plain filters, {type: 'simple', expression} nodes or nested groups. The backend
// flattens the same shapes into the list PAC applies (flatten_filters in
// portal_api/service/datasource_config_builder.py), so what is shown here is what runs.

export const collectExpressions = (node) => {
    if (!node || typeof node !== 'object') {
        return []
    }
    if (Array.isArray(node)) {
        return node.flatMap(collectExpressions)
    }
    if (node.type === 'simple') {
        return node.expression ? [node.expression] : []
    }
    if (Array.isArray(node.expressions)) {
        return node.expressions.flatMap(collectExpressions)
    }
    if (node.type === 'group') {
        return []
    }
    return [node]
}

export const toFilterList = (value) => collectExpressions(value)
